import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { required } from '@utils/validators';

import {
  AutoComplete,
  AutoCompleteField,
  Input,
  InputField,
  Date,
  DateField,
  Photo,
  PhotoField,
  RemoteAutoCompleteField,
  RemoteAutoComplete
} from '@components/form';
import Address, { AddressField } from '@components/form/Address/Address';

import { sexEnum, typeEnum } from '@modules/employees/_employeesEnums';
import { birthNumberToBirthDate } from '@utils/utils';
import { format } from 'date-fns';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { change } from 'redux-form';

const enhance = compose<any, any>(
  connect<any>(
    undefined,
    dispatch => ({
      changeFieldValue: (label, value) => dispatch(change('module-employees', label, value))
    })
  )
);

const View: React.SFC<any> = ({ changeFieldValue }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={8} xl={4} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Fotografie</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <PhotoField component={Photo} name="photo" />
            </Col>
          </Row>
        </Col>

        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Jméno</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id="titleBefore" name="titleBefore" label="Titul před jménem" />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id="firstName" name="firstName" label="Jméno *" validate={required} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id="lastName" name="lastName" label="Přijmení *" validate={required} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id="maidanName" name="maidenName" label="Rodné přijmení" />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id="titleAfter" name="titleAfter" label="Titul za jménem" />
            </Col>
          </Row>
        </Col>

        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Osobní údaje</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DateField
                component={Date}
                id="birthDate"
                name="birthDate"
                label="Datum narození *"
                validate={required}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                id="birthNumber"
                name="birthNumber"
                label="Rodné číslo"
                onBlur={e => {
                  if (e) {
                    const birthNumber = e.target.value;
                    const birthDate = birthNumberToBirthDate(birthNumber);
                    if (birthDate) {
                      changeFieldValue('birthDate', format(birthDate, 'YYYY-MM-DD'));
                    }
                  }
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <AutoCompleteField
                component={AutoComplete}
                id="sex"
                name="sex"
                label="Pohlaví"
                items={sexEnum}
                fullWidth={true}
                labelFunction={o => get(o, 'label')}
                valueFunction={o => get(o, 'id')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                id="driverLicenseTypes"
                name="driverLicenseTypes"
                label="Skupina řidičských oprávnění"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                id="education"
                name="education"
                label="Dosažené vzdělání"
                url={'/metropolis/api/hr/educations'}
                filterActive={true}
                fullWidth={true}
                labelFunction={o => get(o, 'name')}
              />
            </Col>
          </Row>
        </Col>

        <Col
          md={4}
          xl={2}
          className="with-right-divider"
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
        >
          <Row>
            <Col md={12}>
              <h4>Místo narození</h4>
            </Col>
          </Row>
          <AddressField component={Address} name={'birthAddress'} columnStyle={true} />

          <Row>
            <Col md={12}>
              <h4>Kontakt</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} id="phone" name="phone" label="Telefonní číslo" />
            </Col>
            <Col md={12}>
              <InputField component={Input} id="email" name="email" label="Email" />
            </Col>
          </Row>
        </Col>

        <Col md={4} xl={2}>
          <Row>
            <Col md={12}>
              <h4>Informace o zaměstnanci</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                id="personalNumber"
                name="personalNumber"
                label="Osobní číslo *"
                validate={required}
              />
            </Col>
            <Col md={12}>
              <InputField component={Input} id="officerNumber" name="officerNumber" label="Služební číslo" />
            </Col>

            <Col md={12}>
              <AutoCompleteField
                component={AutoComplete}
                id="type"
                name="type"
                label="Typ zaměstnance *"
                items={typeEnum}
                fullWidth={true}
                labelFunction={o => get(o, 'label')}
                valueFunction={o => get(o, 'id')}
                validate={required}
              />
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                id="position"
                name="position"
                label="Pracovní pozice *"
                url={'/metropolis/api/hr/work-positions'}
                filterActive={true}
                fullWidth={true}
                labelFunction={o => get(o, 'name')}
                validate={required}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <Divider />
        </Col>
      </Row>
    </Grid>

    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Adresa trvalého bydliště</h4>
            </Col>
          </Row>

          <AddressField component={Address} name={'address'} />
        </Col>

        <Col md={6}>
          <Row>
            <Col md={12}>
              <h4>Doručovací adresa</h4>
            </Col>
          </Row>

          <AddressField component={Address} name={'correspondenceAddress'} />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormPersonal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormPersonal.tsx